module.exports = __webpack_public_path__ + "static/media/vault-icon.70c4383c.png";